import React, { Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory} from 'react-router';
import ReactSwipe from 'react-swipe';
import NotFound from './../Common/NotFound.js';
import {Panel, Button,Modal,OverlayTrigger,Popover } from 'react-bootstrap';
import { ShareButtons,generateShareIcon } from 'react-share';
// import Geosuggest from 'react-geosuggest';
import Swiper from 'react-id-swiper';


const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class SeedDetails extends Component {
	constructor(props){
		super(props);
		this.state={
			id: this.props.params.Id,
			seedDetails: [],
			deal_options: '',
			details: '',
			offers_details: '',
			test: [],
			s: [],
			hatchary_details: [],
			rate: '',
			res_img: '',
			seller_id: '',
			deal_id: '',
			open: false,
			showModal: false,
			loading: false,
			reqbestPrice: false,
			sname: '',
			session:localStorage.getItem('token'),
			data_status: false,
			coupons:[],
			views_count: '',
			recomends: '',
			seo_title:'',
			seo_desc:'',
			coupon_first: [],
			cpns_list:'',
			
			min_allowed_qty:'',
			min_allowed_qty1:'',
			available_qty:'',
			plsize:0,
			plsizes:[],
			salinities:[],
			millions:'',
			min_allowed_qty_status:false,
			salinity:0,
			seeddates:'',
			start_date:'',
			end_date:'',
			addtocart_msg:'',
			is_cart:0,
			clearcart_status:false,
			addtocart_status:false,
			updatecart_status:false,
			sp_name:'',
			active_date:'',
			date_status:false,
			err_date:'',
			err_date_status:false,
			
			free_ship_msg:'',
			user_zipcode:'',
			free_shipment:'',

			err_pincode:false,
			err_pincode_msg:'',

			product_existed:false,
			emi_opt_desc: '',
			emi_opt_sts:0,

			err_qty_status:false, //checking the status of quantity 
			err_qty_status_1:false, // checking the if the qty is high and setting it to max
			err_qty_msg:'',

			req_confirm_modal:false,
			req_confirm_message:'',
			req_pincode: '',
			req_quantity:'',
			req_state:'',
			req_city:'',
			req_doorno:'',
			wishLst_flag:'',
			page_loading:false,
			shareUrl:'',
			cart_date:'',
			cart_date_active:'',
			cart_qty:'',
			cart_salinity:0,
			cart_pl_size:0,
			date_flag:false,
		}
		this.scroll=this.scroll.bind(this);
		this.modalOpen=this.modalOpen.bind(this);
		this.close=this.close.bind(this);
		localStorage.setItem('seed_id',this.props.params.Id);
		this.getDeviceId=this.getDeviceId.bind(this);
		
		this.decrementMinQty=this.decrementMinQty.bind(this);
		this.updateMinQty=this.updateMinQty.bind(this);
		this.incrementMinQty=this.incrementMinQty.bind(this);
		this.plsizeChange=this.plsizeChange.bind(this);
		this.salinityChange=this.salinityChange.bind(this);
		this.DealPlSalinity=this.DealPlSalinity.bind(this);
		this.getDates=this.getDates.bind(this);
		this.placeOrderModal=this.placeOrderModal.bind(this);
		this.removeCartItems=this.removeCartItems.bind(this);
		this.changeDate=this.changeDate.bind(this);

		this.checkPincode=this.checkPincode.bind(this);
		this.pincodeChange=this.pincodeChange.bind(this);

		this.req_pincodeChange=this.req_pincodeChange.bind(this);
	    this.req_quantityChange=this.req_quantityChange.bind(this);
	    this.req_stateChange=this.req_stateChange.bind(this);
	    this.req_cityChange=this.req_cityChange.bind(this);
		this.req_doornoChange=this.req_doornoChange.bind(this);
		this.reqBestPriceSubmit=this.reqBestPriceSubmit.bind(this);
		this.checkBestPrice=this.checkBestPrice.bind(this);
		this.addToWishlist=this.addToWishlist.bind(this);
		this.ShareFunc=this.ShareFunc.bind(this);
		this.addToWishlistOnload=this.addToWishlistOnload.bind(this);

		// this.onSuggestSelect=this.onSuggestSelect.bind(this);
		this.addtocartOnload=this.addtocartOnload.bind(this);
		this.checkBestPriceOnload=this.checkBestPriceOnload.bind(this);
	}
	// onSuggestSelect(e)
 	// {
	// 	this.setState({
	//       req_city: e.label,
	//     });
	// }
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href="/web/sdetails/"+this.props.params.BrandName+"/"+this.props.params.Id;
		}
		this.DealPlSalinity();
		localStorage.setItem('m_r_s_dt','/sdetails/'+this.props.params.BrandName+"/"+this.props.params.Id);
		localStorage.removeItem('m_r_p_dt');
		this.scroll();
		this.getDeviceId();
		// if(!localStorage.token && !localStorage.user_id)
  		// {
  		// 	localStorage.setItem('m_r_s_dt','/sdetails/'+this.props.params.BrandName+"/"+this.props.params.Id)
  		// 	browserHistory.push('/login');
  		// }
  		// else
  		// {
  		if(localStorage.user_id)
  		{
  			var uid=localStorage.getItem('user_id');
  		}
  		else
  		{
  			uid=0;
  		}
  		
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
  		var data1={from: 'mobile_web',id: this.props.params.Id,uid:uid,token: localStorage.token,source:source,campaign:campaign,url_id:url_id};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'getdealsdetails',
      		dataType:'json',
      		data: {req:data2},
      		success: function(response)
      		{
      			if(response.status==="error")
      			{
      			 	this.setState({
      			 		data_status: true,
      			 	});
      			 	window.location.href=response.redirect;
      			}
      			if(response.message === "Token mismatch")
      			{
      			 	localStorage.removeItem('token');
      			 	localStorage.removeItem('user_id');
      			 	browserHistory.push('/login');
      			}
      			var s = $.makeArray(response.offers_details);
	    		var h = $.makeArray(response.hatchary_details);
	    		var d_opt=$.makeArray(response.deal_options);
	    		this.setState({
	    			loading: true,
	    			seller_id: response.data[0]['deals_data']['seller_id'],
	    			deal_id: response.data[0]['deals_data']['id'],
	    			sp_name: response.data[0]['deals_data']['sname'],
					seedDetails: response.data,
	    			details: response,
	    			test: s[0],
	    			views_count: response.views_count,
	    			recomends: response.recomends,
	    			t: response.data[0],
	    			hatchary_details: h[0],
	    			coupon_first: response.coupons[0],
	    			rate: response.data[0]['deals_data']['rate'],
	    			res_img: response.imgs,
	    			coupons:response.coupons,
	    			cpns_list: response.cpns_list,
	    			
	    			min_allowed_qty:response.data[0]['deals_data']['min_allowed_qty'],
	    			min_allowed_qty1:response.data[0]['deals_data']['min_allowed_qty'],
					available_qty:response.data[0]['deals_data']['available_qty'],
					millions: parseFloat(response.data[0]['deals_data']['min_allowed_qty']) / 1000000,
					start_date:response.start_date,
					end_date:response.end_date,
					is_cart:response.is_cart,
					free_ship_msg:response.free_ship_msg,
					user_zipcode:response.user_zipcode,
					free_shipment:response.free_shipment,

					emi_opt_desc: response.emi_opt_desc,
					emi_opt_sts:response.emi_opt_sts,
					seo_title:h[0]['org_name']+' Aqua Seed Deals',
					seo_desc:'Buy quality '+response.data[0]['deals_data']['sname']  +' Aquaculture seed from CAA approved '+h[0]['org_name']+' and avail free shipment',
					wishLst_flag:response.wishLst_flag,
					cart_date:response.cart_date,
					cart_salinity:response.cart_salinity,
					cart_pl_size:response.cart_pl_size,
	    		});

	    		if(response.cart_qty !==0)
	    		{
	    			this.setState({
	    				min_allowed_qty:response.cart_qty,
	    			})
	    		}
	    		if(response.cart_date !=='')
	    		{
	    			this.setState({
	    				date_flag:true,
	    				// active_date:response.cart_date,
	    			});
	    		}
	    		if(response.cart_pl_size !== 0)
	    		{
	    			this.setState({
	    				plsize:response.cart_pl_size,
	    			})
	    		}
	    		if(response.cart_salinity !== 0)
	    		{
	    			this.setState({
	    				salinity:response.cart_salinity,
	    			})
	    		}
	    		if(response.data[0]['deals_data']['sname'] ===null)
	    		{
	    			this.setState({
	    				seo_desc:'Buy quality '+response.data[0]['deals_data']['oname']  +' Aquaculture seed from CAA approved '+h[0]['org_name']+' and avail free shipment',
	    			});
	    		}
	    		if(d_opt.length >0 )
	    		{
	    			this.setState({
	    				deal_options: d_opt[0],
	    			});
	    		}
	    		if(response.is_cart === 1)
         		{
         			this.setState({
         				addtocart_msg:'GO TO CART',
         				is_cart:response.is_cart,
         			});
         		}
         		else
         		{
         			this.setState({
         				addtocart_msg:'ADD TO CART',
         				is_cart:response.is_cart,
         			});
         		}
	    		document.title=this.state.seo_title;
	    		document.getElementsByTagName("META")[2].content=this.state.seo_desc;
	    		this.getDates();

	    		if(localStorage.user_id && localStorage.token && localStorage.mob_seedaddtocart)
		        {
		        	this.addtocartOnload();
		        }
		        if(localStorage.user_id && localStorage.token && localStorage.mob_seed_checkbestprice)
				{
					this.checkBestPriceOnload();
				}
				if(localStorage.user_id && localStorage.token && localStorage.addtowishlist_onload)
				{
					this.addToWishlistOnload();
				}
	    	}.bind(this),
  			error: function(err)
  			{
  			}
        });
  		// }
  	}
	ShareFunc(evnt)
  	{
		var data1={from: 'mobile_web',type:0,did:evnt};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'createTinyurl',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data){
        		this.setState({
        			msg: data.msg,
        			shareUrl: data.tinyurl,
        		})
        	}.bind(this),
  			error: function(err){
  				// console.log("Error"+err);
  			}
        });
        this.setState({
			open: !this.state.open 
		});
    	setTimeout(() => {this.setState({open: false}); }, 10000);
	}
	reqBestPriceSubmit(event)
	{
		event.preventDefault();
		var quantity = this.refs.req_quantity.value;
		var state = this.refs.req_state.value;
		var city = this.refs.req_city.value;
		var doorno = this.refs.req_doorno.value;
		var pincode=this.refs.req_pincode.value;
		
		var flag=0;
		const namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;

		if(quantity==='' && quantity.length < 1)
		{
			$('#req_quantity_err').text('* enter quantity');
			flag =1;
		}
		if(state==='' && !namePattern.test(state) && state.length < 2)
	    {
	      	$('#req_state_err').text('* enter state');
	      	flag= 1;
	    }
	    if(state !=='' && state.length < 2 && !namePattern.test(state))
	    {
	    	$('#req_state_err').text('* enter valid state');
	    	flag =1;
	    }
	    if(city==='' && !namePattern.test(city))
	    {
	      	$('#req_city_err').text('* enter city');
	      	flag= 1;
	    }
	    if(city !=='' && city.length < 3)
	    {
	    	$('#req_city_err').text('* enter city');
	    	flag = 1;
	    }
	    if(doorno==='' && doorno.length <= 1)
	    {
	    	$('#req_doorno_err').text('* enter address');
	      	flag= 1;
	    }
	    if(doorno!=='' && doorno.length <= 1)
	    {
	    	$('#req_doorno_err').text('* enter address');
	      	flag= 1;
	    }
		if(pincode==='' && pincode.length < 6)
	    {
	    	$('#req_pincode_err').text('* enter valid pincode');
	    	flag= 1;
	    }
	    if(pincode !=='' && pincode.length < 6)
	    {
	    	$('#req_pincode_err').text('* enter valid pincode');
	    	flag= 1;
	    }
	    if(quantity !=='' && quantity < parseInt(this.state.min_allowed_qty1,10))
	    {
	    	$('#req_quantity_err').text('* minimum quantity is '+this.state.min_allowed_qty1);
	    	flag =1;
	    }
	    if(quantity > parseInt(this.state.available_qty,10))
	    {
	    	$('#req_quantity_err').text('* maximum quantity is '+this.state.available_qty);
	    	flag =1;
	    }

	    if(flag===0)
	    {
	    	if(localStorage.user_id)
	  		{
	  			var uid=localStorage.getItem('user_id');
	  		}
	  		else
	  		{
	  			uid=0;
	  		}
	    	if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
	    	// saveBestpriceLead(id,did,dtype,req_qty,address,req_loc,city(selected text value),state(selected text value))
			var data1={from:'mobile_web',id:uid,token:localStorage.token,did:this.props.params.Id,dtype:'0',req_qty:this.state.req_quantity,state:this.state.req_state,city:this.state.req_city,address:this.state.req_doorno,req_loc:this.state.req_pincode,source:source,campaign:campaign,url_id:url_id}
	    	var data2=JSON.stringify(data1);
	    	$.ajax({
	    		method:'POST',
	    		dataType:'json',
	    		data:{req:data2},
	    		url:baseUrl+'saveBestpriceLead',
	    		success:function(data)
	    		{
	    			if(data.status==='success')
	    			{
	    				this.setState({
	    					reqbestPrice:false,
	    					req_confirm_modal:true,
	    					req_confirm_message:data.message,
	    				});
	    			}
	    		}.bind(this),
	    		error:function(err)
	    		{
	    			
	    		}
	    	});
	    }
	}
	req_quantityChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value))
	    {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	req_quantity: x,
	        });
	    }
	}
	req_doornoChange(event)
	{
		this.setState({
			req_doorno:event.target.value,
		});
	}
	req_cityChange(event)
	{
		// this.setState({
		// 	req_city:event.target.value,
		// });
		var x=event.target.value;
		var namePattern = /^[a-z A-Z]+$/;
	    if(!namePattern.test(event.target.value) && x !== '')
	    {
	        x = event.target.value.replace(namePattern,"");
	    }
	   	else
	    {
	    	this.setState({
	    	   	req_city: event.target.value,
	    	});	
	    }
	}
	req_stateChange(event)
	{
		var x=event.target.value;
		var namePattern = /^[a-z A-Z]+$/;
	    if(!namePattern.test(event.target.value) && x !== '')
	    {
	        x = event.target.value.replace(namePattern,"");
	    }
	   	else
	    {
	    	this.setState({
	    	   	req_state: event.target.value,
	    	});	
	    }
	}
	req_pincodeChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value))
	    {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	req_pincode: x,
	        });
	    }
	}
	checkBestPriceOnload()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			browserHistory.push('/login');
		}
		else
		{
			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}

			if(localStorage.user_id)
			{
				var uid=localStorage.getItem('user_id');
			}
			else
			{
				uid=0;
			}
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from: 'mobile_web',did:this.props.params.Id,id:uid,dtype:0,source:source,campaign:campaign,url_id:url_id};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		    	method:'POST',
		    	dataType:'json',
		    	url:baseUrl+'checkBestPriceLead',
		    	data:{req:data2},
		    	success:function(data)
		    	{
		    		if(data.status==='success' && data.proceed===1)
		    		{
		    			this.setState({
		    				reqbestPrice:true,
		    			});
		    			localStorage.removeItem('mob_seed_checkbestprice');
		    		}
		    		else if(data.status==='success' && data.proceed === 0)
		    		{
		    			// alert(data.msg);
		    			this.setState({
		    				req_confirm_modal:true,
		    				req_confirm_message:data.msg,
		    			});
		    			localStorage.removeItem('mob_seed_checkbestprice');
		    		}
				}.bind(this),
		    	error:function(err)
		    	{
		    		
		    	}
		    });
		}
	}

	checkBestPrice()
	{
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('mob_seed_checkbestprice','1');
			browserHistory.push('/login');
		}
		else
		{
			if(localStorage.user_id)
	  		{
	  			var uid=localStorage.getItem('user_id');
	  		}
	  		else
	  		{
	  			uid=0;
	  		}
	    	if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}

			var data1={from:'mobile_web',did:this.props.params.Id,id:uid,dtype:0,source:source,campaign:campaign,url_id:url_id};
		    var data2=JSON.stringify(data1);
		    $.ajax({
		    	method:'POST',
		    	dataType:'json',
		    	url:baseUrl+'checkBestPriceLead',
		    	data:{req:data2},
		    	success:function(data)
		    	{
		    		if(data.status==='success' && data.proceed===1)
		    		{
		    			this.setState({
		    				reqbestPrice:true,
		    			});
		    			localStorage.removeItem('mob_seed_checkbestprice');
		    		}
		    		else if(data.status==='success' && data.proceed === 0)
		    		{
		    			// alert(data.msg);
		    			this.setState({
		    				req_confirm_modal:true,
		    				req_confirm_message:data.msg,
		    			});
		    			localStorage.removeItem('mob_seed_checkbestprice');
		    		}
				}.bind(this),
		    	error:function(err)
		    	{
		    		
		    	}
		    });
		}
	}
	checkPincode()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(this.refs.pincode.value.length ===6)
		{
			var data1={from:'mobile_web',id:uid,token:localStorage.token,type:0,did:this.props.params.Id,zip:this.refs.pincode.value,device_id:localStorage.getItem('push_device_id'),source:source,campaign:campaign,url_id:url_id}
	    	var data2=JSON.stringify(data1);
		    $.ajax({
		        method: 'POST',
		        url: baseUrl+'checkFreeshipment',
		        dataType: 'json',
		        data:{req: data2},
		        success: function(data)
		        {
		          this.setState({
		          		free_ship_msg:data.msg,
		          });	          
		        }.bind(this),
		        error: function(err)
		        {
		        
		        }
		    });	
		}
		else
		{
			this.setState({
				err_pincode:true,
				// err_pincode_msg:'* Invalid pincode',
				free_ship_msg:'Invalid Pincode',
			});
		}
	}
	pincodeChange()
	{
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(this.refs.pincode.value)) 
	    {
	        var x = this.refs.pincode.value.replace(invalidChars,"");
	    }
	    else
	    {
	        this.setState({
	          err_pincode: true,
	        });
	    }
	    this.setState({
			user_zipcode:x,
			err_pincode:false,
		});
	}
	placeOrderModal()
	{
		if(this.state.addtocart_msg ==="GO TO CART")
		{
			browserHistory.push('/mycart');
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			if(this.state.date_flag===true)
			{
				this.setState({
					err_date:'',
					err_date_status:false,
				});
				localStorage.setItem('mob_seedaddtocart','1');
				localStorage.setItem('mob_seed_addtocart_qty',this.state.min_allowed_qty);
				localStorage.setItem('mob_seed_addtocart_pick_date',this.state.active_date);
				localStorage.setItem('mob_seed_addtocart_salinity',this.state.salinity);
				localStorage.setItem('mob_seed_addtocart_plsize',this.state.plsize);
				browserHistory.push('/login');
			}
			else
			{
				this.setState({
					err_date:'* Please Select Pickup Date',
					err_date_status:true,
				});
				alert('* Please Select Pickup Date');
			}
		}
		else
		{
			if(this.state.date_flag===true)
			{
				this.setState({
					err_date:'',
					err_date_status:false,
				});
			}
			else
			{
				this.setState({
					err_date:'* Please Select Pickup Date',
					err_date_status:true,
				});
				alert('* Please Select Pickup Date');
			}
			if(this.state.date_flag===true)
			{	
				if(this.state.addtocart_msg ==="ADD TO CART" || this.state.addtocart_msg ==="UPDATE CART")
				{
					var quantity='';
					
					if(this.refs.input_minqty.value < parseInt(this.state.min_allowed_qty1,10) || this.refs.input_minqty.value==="NaN")
					{
						this.setState({
							err_qty_status_1: true,
							err_qty_msg: "* Minimum Quantity is "+this.state.min_allowed_qty1,
							min_allowed_qty:this.state.min_allowed_qty1,
							millions:parseInt(this.state.min_allowed_qty1,10) / 1000000,
						});
						quantity=this.state.min_allowed_qty1;
					}
					else if(this.refs.input_minqty.value === '')
					{
						this.setState({
							min_allowed_qty:this.state.available_qty,
			 				millions:parseInt(this.state.available_qty,10) / 1000000,
			 				err_qty_status_1:true,
			 				err_qty_msg:"* Minimum Quantity is "+this.state.min_allowed_qty1,
			 			});
					}
					else if(this.refs.input_minqty.value > parseInt(this.state.available_qty,10))
	 				{
	 					this.setState({
			 				min_allowed_qty:this.state.available_qty,
			 				millions:parseInt(this.state.available_qty,10) / 1000000,
			 				err_qty_status_1:true,
							err_qty_msg:'* Maximum quantity is '+this.state.available_qty,
			 			});
	 				}
	 				else
					{
						this.setState({
							err_qty_status_1:false,
							err_qty_msg:'',
						});
						quantity=this.refs.input_minqty.value;
					}
					if(this.refs.input_minqty.value >= this.state.min_allowed_qty1 && this.refs.input_minqty.value !=="NaN")
					{
						if(this.state.plsize===0)
						{
							var seed_plsize='PLSIZE';
						}
						else
						{
							seed_plsize=this.state.plsize;
						}
						if(this.state.salinity===0)
						{
							var seed_salinity='SALINITY';
						}
						else
						{
							seed_salinity=this.state.salinity;
						}
						if(localStorage.user_id)
						{
							var uid=localStorage.getItem('user_id');
						}
						else
						{
							uid=0;
						}
						if(this.state.active_date==='')
						{
							var pickup_date=this.state.cart_date_active;
						}
						else
						{
							pickup_date=this.state.active_date;
						}

						
						if(localStorage.source)
						{
							var source=localStorage.getItem('source');
						}
						else
						{
							source='';
						}
						if(localStorage.campaign)
						{
							var campaign=localStorage.getItem('campaign');
						}
						else
						{
							campaign='';
						}
						if(localStorage.url_id)
						{
							var url_id=localStorage.getItem('url_id');
						}
						else
						{
							url_id='';
						}
						var data1={from:'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:this.props.params.Id,deal_type:0,quantity:quantity,pl_size:seed_plsize,salinity:seed_salinity,pickup_date:pickup_date,source:source,campaign:campaign,url_id:url_id}
					    var data2=JSON.stringify(data1);
					    $.ajax({
							method:'post',
							dataType:'json',
							url: baseUrl+'addToCart',
							data:{req:data2},
							success:function(data){
								if(data.status==="success" && data.message==="Added to cart")
								{
									this.setState({
										addtocart_msg:'GO TO CART',
										addtocart_status:true,
										is_cart:1,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								if(data.status==="success" && data.message==="Cart Updated")
								{
									this.setState({
										updatecart_status:true,
										addtocart_msg:'GO TO CART',
										is_cart:1,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								if(data.status==="error" && data.cart_flag===0)
								{
									this.setState({
										clearcart_status: true,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								
								if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
								{
									this.setState({
										addtocart_msg:'GO TO CART',
										addtocart_status:true,
										is_cart:data.cart_flag,
										product_existed:true,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
							}.bind(this),
							error:function(err)
							{
								localStorage.removeItem('mob_seedaddtocart');
								localStorage.removeItem('mob_seed_addtocart_qty');
								localStorage.removeItem('mob_seed_addtocart_pick_date');
								localStorage.removeItem('mob_seed_addtocart_salinity');
								localStorage.removeItem('mob_seed_addtocart_plsize');
							}
						});
						}
					}
				}
		}
	}
	addtocartOnload()
	{
		if(this.state.addtocart_msg ==="GO TO CART")
		{
			browserHistory.push('/mycart');
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('mob_seedaddtocart','1');
			localStorage.setItem('mob_seed_addtocart_qty',this.state.min_allowed_qty);
			browserHistory.push('/login');
		}
		else
		{
			if(localStorage.mob_seed_addtocart_pick_date)
			{	
				// if(this.state.addtocart_msg ==="Add to Cart" || this.state.addtocart_msg ==="Update Cart")
				//{
					var quantity='';
					if(localStorage.mob_seed_addtocart_qty)
					{
						quantity=localStorage.getItem('mob_seed_addtocart_qty');
					}
					else
					{
						quantity='';
					}
					if(quantity < parseInt(this.state.min_allowed_qty1,10) || quantity==="NaN")
					{
						this.setState({
							err_qty_status_1: true,
							err_qty_msg: "* Minimum Quantity is "+this.state.min_allowed_qty1,
							min_allowed_qty:this.state.min_allowed_qty1,
							millions:parseInt(this.state.min_allowed_qty1,10) / 1000000,
						});
						quantity=this.state.min_allowed_qty1;
					}
					else if(quantity === '')
					{
						this.setState({
							min_allowed_qty:this.state.available_qty,
			 				millions:parseInt(this.state.available_qty,10) / 1000000,
			 				err_qty_status_1:true,
			 				err_qty_msg:"* Minimum Quantity is "+this.state.min_allowed_qty1,
			 			});
					}
					else if(quantity > parseInt(this.state.available_qty,10))
	 				{
	 					this.setState({
			 				min_allowed_qty:this.state.available_qty,
			 				millions:parseInt(this.state.available_qty,10) / 1000000,
			 				err_qty_status_1:true,
							err_qty_msg:'* Maximum quantity is '+this.state.available_qty,
			 			});
	 				}
	 				else
					{
						this.setState({
							err_qty_status_1:false,
							err_qty_msg:'',
						});
						quantity=localStorage.getItem('mob_seed_addtocart_qty');
					}
					if(quantity >= this.state.min_allowed_qty1 && quantity !=="NaN")
					{
						
						if(localStorage.mob_seed_addtocart_plsize && localStorage.mob_seed_addtocart_plsize !=='0')
						{
							var seed_plsize=localStorage.getItem('mob_seed_addtocart_plsize');
						}
						else
						{
							seed_plsize='PLSIZE';
						}
						if(localStorage.mob_seed_addtocart_salinity && localStorage.mob_seed_addtocart_salinity !=='0')
						{
							var seed_salinity=localStorage.getItem('mob_seed_addtocart_salinity');
						}
						else
						{
							seed_salinity='SALINITY';
						}
						if(localStorage.mob_seed_addtocart_pick_date)
						{
							var pickup_date=localStorage.getItem('mob_seed_addtocart_pick_date');
						}
						else
						{
							pickup_date='';
						}
						if(localStorage.user_id)
				  		{
				  			var uid=localStorage.getItem('user_id');
				  		}
				  		else
				  		{
				  			uid=0;
				  		}
						if(localStorage.source)
						{
							var source=localStorage.getItem('source');
						}
						else
						{
							source='';
						}
						if(localStorage.campaign)
						{
							var campaign=localStorage.getItem('campaign');
						}
						else
						{
							campaign='';
						}
						if(localStorage.url_id)
						{
							var url_id=localStorage.getItem('url_id');
						}
						else
						{
							url_id='';
						}
						var data1={from:'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:this.props.params.Id,deal_type:0,quantity:quantity,pl_size:seed_plsize,salinity:seed_salinity,pickup_date:pickup_date,source:source,campaign:campaign,url_id:url_id}
					    var data2=JSON.stringify(data1);
					    $.ajax({
							method:'post',
							dataType:'json',
							url: baseUrl+'addToCart',
							data:{req:data2},
							success:function(data){
								if(data.status==="success" && data.message==="Added to cart")
								{
									this.setState({
										addtocart_msg:'Go to Cart',
										addtocart_status:true,
										is_cart:1,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								if(data.status==="success" && data.message==="Cart Updated")
								{
									this.setState({
										updatecart_status:true,
										addtocart_msg:'Go to Cart',
										is_cart:1,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								if(data.status==="error" && data.cart_flag===0)
								{
									this.setState({
										clearcart_status: true,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
								
								if(data.status==="error" && data.message==="Product already added to the cart" && data.cart_flag ===1)
								{
									this.setState({
										addtocart_msg:'Go to Cart',
										addtocart_status:true,
										is_cart:data.cart_flag,
										product_existed:true,
									});
									localStorage.removeItem('mob_seedaddtocart');
									localStorage.removeItem('mob_seed_addtocart_qty');
									localStorage.removeItem('mob_seed_addtocart_pick_date');
									localStorage.removeItem('mob_seed_addtocart_salinity');
									localStorage.removeItem('mob_seed_addtocart_plsize');
								}
							}.bind(this),
							error:function(err)
							{
								localStorage.removeItem('mob_seedaddtocart');
								localStorage.removeItem('mob_seed_addtocart_qty');
								localStorage.removeItem('mob_seed_addtocart_pick_date');
								localStorage.removeItem('mob_seed_addtocart_salinity');
								localStorage.removeItem('mob_seed_addtocart_plsize');
							}
						});
					}
				//}
			}
		}
	}
	removeCartItems()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}

		if(this.state.active_date==='')
		{
			var pickup_date=this.state.cart_date_active;
		}
		else
		{
			pickup_date=this.state.active_date;
		}
  		var data1={from: 'mobile_web',id:uid,token:localStorage.getItem('token'),deal_id:this.props.params.Id,deal_type:0,quantity:this.refs.input_minqty.value,pl_size:this.state.plsize,salinity:this.state.salinity,pickup_date:pickup_date,source:source,campaign:campaign,url_id:url_id}
	    var data2=JSON.stringify(data1);
	    $.ajax({
			method:'post',
			dataType:'json',
			url: baseUrl+'replaceCart',
			data:{req:data2},
			success:function(data)
			{
				if(data.status==="success" && data.cart_flag===1)
				{
					this.setState({
						addtocart_msg:'GO TO CART',
						clearcart_status:false,
						addtocart_status:true,
					});
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
  	}
	DealPlSalinity()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		var data1={from: 'mobile_web',deal_id: this.props.params.Id,id:uid,token: localStorage.getItem('token')};
		var data2=JSON.stringify(data1);
		$.ajax({
	        method: 'POST',
	        url: baseUrl+'DealPlSalinity',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          if(data.status==="ok")
	          {
	          	this.setState({
	          		plsizes:data.plsizes,
	          		salinities:data.salinities,
	          	});
	          }
	          if(data.status==="error" && data.message==="Token mismatch")
	          {
	             localStorage.removeItem('user_id');
	          	 localStorage.removeItem('token');
	          	 window.location.reload();
	          }
	        }.bind(this),
	        error: function(err)
	        {
	        	console.log(err);
	        }
	    });
	}
	salinityChange()
	{
		this.setState({
			salinity:this.refs.select_salinity.value,
		})
		if(this.state.is_cart===1)
		{
			this.setState({
				addtocart_msg:'UPDATE CART',
			});
		}
	}
	plsizeChange()
	{
		this.setState({
			plsize:this.refs.select_plsize.value,
		});
		if(this.state.is_cart===1)
		{
			this.setState({
				addtocart_msg:'UPDATE CART',
			});
		}
	}
	decrementMinQty()
	{
		if(this.state.min_allowed_qty !== this.state.min_allowed_qty1 && this.state.min_allowed_qty > this.state.min_allowed_qty1)
		{
			var cal=parseInt(this.state.min_allowed_qty,10) - 100000;
			this.setState({
				min_allowed_qty:parseInt(this.state.min_allowed_qty,10) - 100000,
				min_allowed_qty_status:false,
				millions: cal / 1000000,
				err_qty_status_1:false,
				err_qty_msg:'',
			});	
		}
		else
		{
			this.setState({
				min_allowed_qty:parseInt(this.state.min_allowed_qty1,10),
				millions:parseInt(this.state.min_allowed_qty1,10) / 1000000,
				err_qty_status_1:true,
				err_qty_msg:'* Minimum quantity is '+this.state.min_allowed_qty1,
			})
		}
		if(this.state.is_cart===1)
		{
			this.setState({
				addtocart_msg:'UPDATE CART',
			});
		}
	}
	updateMinQty(event)
	{
		this.setState({
			err_qty_status_1:false,
			err_qty_msg:'',
		});
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value))
	    {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	min_allowed_qty: x,
	        	millions: parseInt(x,10) / 1000000,
	        });
	    }
		if(this.refs.input_minqty.value > parseInt(this.state.available_qty,10))
 		{
 			this.setState({
 				min_allowed_qty:this.state.available_qty,
 				millions:parseInt(this.state.available_qty,10) / 1000000,
 				err_qty_status_1:true,
				err_qty_msg:'* Maximum quantity is '+this.state.available_qty,
 			});
 		}
 		else if(this.refs.input_minqty.value==="")
 		{
 			this.setState({
 				min_allowed_qty:'',
 				err_qty_status_1:true,
 				err_qty_msg:'* Minimum quantity is '+this.state.min_allowed_qty1,
 				millions:0,
 			});
 		}
 	}
	incrementMinQty()
	{
		var cal=parseInt(this.state.min_allowed_qty,10) + 100000;
		if(cal <= this.state.available_qty)
		{
			this.setState({
				min_allowed_qty:parseInt(this.state.min_allowed_qty,10) + 100000,
				millions: cal / 1000000,
				err_qty_status_1:false,
				err_qty_msg:'',
			});	
		}
		else if(this.refs.input_minqty.value === '')
		{
			this.setState({
				min_allowed_qty:this.state.min_allowed_qty1,
				millions:parseInt(this.state.min_allowed_qty1,10) / 1000000,
				err_qty_status_1:true,
				err_qty_msg:'* Minimum quantity is '+this.state.min_allowed_qty1,
			});
		}
		else
		{
			this.setState({
				min_allowed_qty:parseInt(this.state.available_qty,10),
				millions:parseInt(this.state.available_qty,10) / 1000000,
				min_allowed_qty_status: true,
				err_qty_status_1:true,
				err_qty_msg:'* Maximum quantity is '+this.state.available_qty,
			});
		}
		if(this.state.is_cart===1)
		{
			this.setState({
				addtocart_msg:'UPDATE CART',
			});
		}
	}
	modalOpen()
	{
		this.setState({
			showModal: true,
		});
	}
	closeModal()
	{
		this.setState({
			showModal: false,
			reqbestPrice:false,
			product_existed:false,
		});
	}
	close()
	{
		this.setState({
			showModal: false,
			reqbestPrice:false,
			clearcart_status:false,
			product_existed:false,
			req_confirm_modal:false,
		});
	}
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	        var uid=localStorage.user_id;
	    }
	    else
	    {
	      uid=0;
	    }
	    var data1={from: 'mobile_web',id: uid, device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          
	        },
	        error: function(err){
	        }
	    });
    }
	scroll()
	{
		var lastScroll = 0;
		var scrollUpStart = 0;
		$(window).on('scroll',function() {
		var scroll = $(window).scrollTop();
		if(scroll === 0){
			$(".page_hdr").addClass("dtl_pg_hdr");
		}
		else if(lastScroll > scroll) {
			if (scrollUpStart < scroll) {
				scrollUpStart = scroll;
			}
			if (scrollUpStart - scroll >= 200) {
				$(".page_hdr").addClass("dtl_pg_hdr");
			}
			} 
		else {
			scrollUpStart = 0;
			$(".page_hdr").removeClass("dtl_pg_hdr");
		}
			lastScroll = scroll;
		});
	}
	changeDate(dt)
	{
		this.setState({
			active_date:dt,
			date_flag:true,
			err_date_status:false,
			cart_date_active:dt,
		});
		if(this.state.is_cart===1)
		{
			this.setState({
				addtocart_msg:'UPDATE CART',
			})
		}
	}
	getDates()
	{
		var day = 1000*60*60*24;
		var d1=Date.parse(this.state.start_date);
		var d2=Date.parse(this.state.end_date);
		var d3=Date.parse(this.state.cart_date);
		var date1 = new Date(d1);
		var date2 = new Date(d2);
		var date3 = new Date(d3);
		var diff = (date2.getTime()- date1.getTime())/day;
		var dates = [];
		var months = new Array(12);
			months[0] = "Jan";
			months[1] = "Feb";
			months[2] = "Mar";
			months[3] = "Apr";
			months[4] = "May";
			months[5] = "Jun";
			months[6] = "Jul";
			months[7] = "Aug";
			months[8] = "Sep";
			months[9] = "Oct";
			months[10] = "Nov";
			months[11] = "Dec";
 		for(var i=0;i<=diff; i++)
		{
		    var xx = date1.getTime()+day*i;
		    var yy = new Date(xx);
		    var monthName=months[yy.getMonth()];
		    var tt = yy.getDate()+" "+monthName+" "+yy.getFullYear();
		    dates[i+1] = tt;
		}
		if(this.state.cart_date !=='')
		{
			var a = date3.getTime();
		    var b = new Date(a);
		    monthName=months[b.getMonth()];
		    var c = b.getDate()+" "+monthName+" "+b.getFullYear();
			this.setState({
		    	cart_date_active:c,
		    })
		}
		this.setState({
		    seeddates: dates,
		});
	}
	addToWishlistOnload()
 	{
 		if(!localStorage.user_id && !localStorage.token)
 		{
 			localStorage.setItem('addtowishlist_onload','1');
 			browserHistory.push('/login');
 		}
 		else
 		{
 			this.setState({
 				page_loading:true,
 			});
 			if(localStorage.user_id)
 			{
 				var uid=localStorage.user_id;
 			}
 			else
 			{
 				uid=0;
 			}
 			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
	 		var data1={from:'mobile_web',id:uid,token:localStorage.token,type:0,did:this.props.params.Id,source:source,campaign:campaign,url_id:url_id};
	 		var data2=JSON.stringify(data1);
	 		$.ajax({
	 			method:'POST',
	 			dataType:'json',
	 			data:{req:data2},
	 			url:baseUrl+'addToWishlist',
	 			success:function(data)
	 			{
	 				if(data.status==='success' && data.message==='Added to wish list')
	 				{
	 					this.setState({
	 						wishLst_flag:1,
	 						page_loading:false,
	 					});
	 					localStorage.removeItem('addtowishlist_onload');
	 				}
	 				else
	 				{
	 					this.setState({
	 						page_loading:false,
	 					});
	 					localStorage.removeItem('addtowishlist_onload');
	 				}
	 			}.bind(this),
	 			error:function(err)
	 			{
	 				this.setState({
	 					page_loading:false,
	 				});
	 			}
	 		});
 		}
	}
	addToWishlist()
 	{
 		if(!localStorage.user_id && !localStorage.token)
 		{
 			localStorage.setItem('addtowishlist_onload','1');
 			browserHistory.push('/login');
 		}
 		else
 		{
 			this.setState({
 				page_loading:true,
 			});
 			if(localStorage.user_id)
 			{
 				var uid=localStorage.user_id;
 			}
 			else
 			{
 				uid=0;
 			}
 			if(localStorage.source)
			{
				var source=localStorage.getItem('source');
			}
			else
			{
				source='';
			}
			if(localStorage.campaign)
			{
				var campaign=localStorage.getItem('campaign');
			}
			else
			{
				campaign='';
			}
			if(localStorage.url_id)
			{
				var url_id=localStorage.getItem('url_id');
			}
			else
			{
				url_id='';
			}
	 		var data1={from:'mobile_web',id:uid,token:localStorage.token,type:0,did:this.props.params.Id,source:source,campaign:campaign,url_id:url_id};
	 		var data2=JSON.stringify(data1);
	 		$.ajax({
	 			method:'POST',
	 			dataType:'json',
	 			data:{req:data2},
	 			url:baseUrl+'addToWishlist',
	 			success:function(data)
	 			{
	 				if(data.status==='success' && data.message==='Added to wish list')
	 				{
	 					this.setState({
	 						wishLst_flag:1,
	 						page_loading:false,
	 					});
	 					localStorage.removeItem('addtowishlist_onload');
	 				}
	 				else
	 				{
	 					this.setState({
	 						page_loading:false,
	 					});
	 					localStorage.removeItem('addtowishlist_onload');
	 				}
	 			}.bind(this),
	 			error:function(err)
	 			{
	 				this.setState({
	 					page_loading:false,
	 				});
	 			}
	 		});
 		}
	}
	render()
	{
		const params = {
	      paginationClickable: true,
	      spaceBetween: 5,
	      slidesPerView: 6
	    }
	    var shareUrl=this.state.shareUrl;
	    var title = "Hey Click here "+ shareUrl+ " to check "+this.state.sp_name+" from AquaDeals.";
	    var description=shareUrl;
	   	var x=$.makeArray(this.state.seeddates);
		var seeddates=x.map(function(dt,index)
		{
			return(
				 <div className={this.state.active_date===dt || this.state.cart_date_active ===dt ? "seed_dateblk seed_dateblk_active" : "seed_dateblk"} key={index} onClick={()=>{this.changeDate(dt)}}>
					<div className="seed_date">{dt}</div>
				</div>
			);
		}.bind(this));
		var img_array = $.makeArray(this.state.res_img);
		var product_imgs = img_array.map(function(image, index){
        	return (<img src={'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/'+image.img} alt=" " height="355px" />)
		});
		var views_cnt=this.state.details.views_count >=1 ? <span><img src={'https://aquadeals.in/admin/assets/icons/web_icons/views.png'} width="20px" role="presentation"/> {this.state.details.views_count}</span> : '';
		var rec_cnt=this.state.details.recomends >=1 ? <span className="recommended_img"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/recommended1.png'} width="16px"  role="presentation"/> &nbsp;{this.state.details.recomends}</span> : '';
		var details = this.state.seedDetails.map((details, index) => (<ProductDetails key={details.deals_data.id} data={details} views_cnt={views_cnt} rec_cnt={rec_cnt} /> ));
		// var shipment= this.state.details.free_shipment === '0' ? '' : <h5><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/shipping_van.png'} alt=" " width="20px"  /></i>{this.state.details.shipping_desc}</h5>;
		// var credit = this.state.details.credit_facility === '0' ? '' : <h5><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/credit_ava.png'} alt=" " /></i>{this.state.details.credit_title} </h5>;
		var recommendation = this.state.recomends >= 1 ? <span><img src={'https://aquadeals.in/admin/assets/icons/web_icons/recommended1.png'} alt=" " style={{width:'16px',position:'relative',top:'-1px'}}/> {this.state.recomends}</span> : '';
		var getcoupons='';
		if(this.state.coupons.length > 0 )
		{
			getcoupons="coupons";
			const descriptionTop = (
				  <Popover className="in" id="popover-positioned-top">
					    {this.state.coupon_first.description}
				  </Popover>
			);
			const couponsList = (
				<Popover id="popover-positioned-top1">
					{this.state.cpns_list.replace(/,\s*$/, "")}
				</Popover>
			);
			if(this.state.coupons.length === 1)
			{
				getcoupons=<div className="row" style={{paddingTop:'10px',paddingBottom:'10px'}}>
								<div className="col-xs-6 col-md-6 col-xs-offset-3 col-md-offset-3">
									<div className="mob_new_coupon_blk">
										<i className="coupon_left_img">
											<img src={'https://aquadeals.in/admin/assets/icons/web_icons/coupon_left.png'}  alt=" " />
										</i>
										<div className="coupon_text">{this.state.coupon_first.coupon_code}</div>
										<OverlayTrigger trigger="focus" placement="top" overlay={descriptionTop}>
						   					<Button className="coupon_info_img"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png'} alt=" " /></Button>
						   				</OverlayTrigger>
					   				</div>
								</div>
							</div>	
			}
			else
			{
			 getcoupons=<div className="row" style={{paddingTop:'10px',paddingBottom:'10px'}}>
							<div className="col-md-6 col-xs-6 col-sm-6 col-xs-offset">
								<div className="mob_new_coupon_blk">
									<i className="coupon_left_img">
										<img src={'https://aquadeals.in/admin/assets/icons/web_icons/coupon_left.png'} alt=" "/>
									</i>
									<div className="coupon_text">{this.state.coupon_first.coupon_code}</div>
									<OverlayTrigger trigger="focus" placement="top" overlay={descriptionTop}>
					   					<Button className="coupon_info_img"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/coupon_info.png'} alt=" " /></Button>
					   				</OverlayTrigger>
				   				</div>
							</div>
							<div className="col-md-6 col-xs-6 col-sm-6" >
								<OverlayTrigger trigger="focus" placement="top" overlay={couponsList}>
									<Button className="applied_coupons">Applied coupons</Button>
								</OverlayTrigger>
							</div>
						</div>	
			}
		}
		else
		{
		    getcoupons='';
		}
		var plsizes=this.state.plsizes.map(function(pl,index)
		{
			return(
				<option key={pl} value={pl}>{pl}</option>
			);
		});
		var salinities=this.state.salinities.map(function(sal,index)
		{
			return(
				<option key={sal} value={sal}>{sal}</option>
			);
		});

		// errors of the req form 
		$('#req_quantity').keyup(function(){
			$('#req_quantity_err').text('');
		});
		$('#req_state').keyup(function(){
			$('#req_state_err').text('');
		});
		$('#req_city').keyup(function(){
			$('#req_city_err').text('');
		});
		$('#req_doorno').keyup(function(){
			$('#req_doorno_err').text('');
		});
		$('#req_pincode').keyup(function(){
			$('#req_pincode_err').text('');
		});

		var wishLst_flag='';
		if(this.state.wishLst_flag===1)
		{
			wishLst_flag=<div className="goto_wish_blk">
							<div className="col-md-6 col-sm-6 col-xs-6 first_blk">
								<Link to={'/wishlist'}>
									<i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/wish_list_filled.png'} alt="" width="12px" /></i> Go to wishlist
								</Link>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-6 second_blk">
								<Link className="share_list1" onClick={()=>{this.ShareFunc(this.state.seedid)}}>
									<i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/share1.png'} alt="share" width="19px" /></i> Share
								</Link>
								<div>
								    <Panel className="seed_full_panel1" collapsible expanded={this.state.open}>
								        <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								           	<FacebookIcon size={32} round />
								        </FacebookShareButton>
								        <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								     	   	<TwitterIcon size={32} round />
								        </TwitterShareButton>
									    <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								      		<GooglePlusIcon size={32} round />
								        </GooglePlusShareButton>
								    </Panel>
								</div>
							</div>
						</div>;
		}
		else
		{
			wishLst_flag=<div className="addto_wish_blk">
							<div className="col-md-6 col-sm-6 col-xs-6 first_blk">
								<Link onClick={()=>{this.addToWishlist()}}><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/wish_list_unfilled.png'} alt="" width="12px" /></i> Add to wishlist
								</Link>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-6 second_blk">
								<Link className="share_list1" onClick={()=>{this.ShareFunc(this.state.seedid)}}>
									<i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/share1.png'} alt="share" width="19px" /></i> Share
								</Link>
								<div>
								    <Panel className="seed_full_panel1" collapsible expanded={this.state.open}>
								        <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								           	<FacebookIcon size={32} round />
								        </FacebookShareButton>
								        <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								     	   	<TwitterIcon size={32} round />
								        </TwitterShareButton>
									    <GooglePlusShareButton url={shareUrl} quote={title} description={description} className="test_share1">
								      		<GooglePlusIcon size={32} round />
								        </GooglePlusShareButton>
								    </Panel>
								</div>
							</div>
						</div>;
		}
	return(
	<div className="mob_deals seed_full_details_page">
		{this.state.loading && !this.state.data_status ? 
		    <div>
				<div className="page_hdr dtl_pg_hdr">
					<div className="container-fluid">
						<h5><Link onClick={()=>{browserHistory.goBack();}}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></Link>{this.state.hatchary_details.org_name}</h5>
						<a href="/" className="home_newicon"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home1.png'} alt="Home"/></a>
					</div>
				</div>
				<section className="container-fluid">
					<div className="row lst_img" style={{position:'relative'}} >
						<ReactSwipe ref="reactSwipe" className="carousel item" swipeOptions={{
				  			continuous: true,
				  			disableScroll: false,
				  			stopPropagation: false,
				  			callback: function(index, elem) {},
				  			transitionEnd: function(index, elem) {}
							}} key={product_imgs.length}>
								{product_imgs} 
						</ReactSwipe>
						<div className="seed_view_rec_blk">{views_cnt} &nbsp; &nbsp; {recommendation}</div>
						{/* <img src={'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/'+this.state.res_img} alt="Deal_img" /> */}
					</div>
					<div className="row deal_name">
						<div className="col-md-12 col-sm-12 col-xs-12">
							{details}
						</div>
					</div>
					<section className="row deal_name">
						{wishLst_flag}
					</section>
					<div className="row deal_name">	
						<div className="block_header">
							<h4 className="mob_seed_h4">Discount & Offers</h4>
						</div>
						<div className="seed_full_cash_block col-md-12">
							{this.state.test.aqua_cash_title ? <h5 className="book_aquacash" style={{clear:'both'}}><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/nav_aquacash.png'} alt=" " width="15px" /></i>{this.state.test.aqua_cash_title}</h5> : ''}
							{this.state.test.full_aquacash_back_title ? <h5 className="cashback" style={{color:'#666'}}><i style={{ display: 'block',float: 'left',paddingRight: '0px!important', marginRight: '4px'}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/newcashback.png'} alt=" " width="18px" /></i>{this.state.test.full_aquacash_back_title}</h5> : ''}
							{this.state.test.pur_ern_ofr_desc ? <h5 style={{color:'#666',fontSize:'11px',marginBottom:'15px'}}><i style={{ display: 'block',float: 'left',marginRight: '10px'}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/nav_aquacash.png'} alt=" " width="15px" /></i>{this.state.test.pur_ern_ofr_desc}</h5> : ''}
							{this.state.emi_opt_sts === 1 ? <h5 style={{color:'#666',fontSize:'11px',marginBottom:'15px'}}><i style={{ display: 'block',float: 'left',marginRight: 10+'px'}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/emi.png'} alt=" " width="15px" /></i>{this.state.emi_opt_desc}</h5> : ''}

						</div>
					</div>
						<div className="clr"></div>
				</section>
				{this.state.coupons.length > 0 ? 
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4 ">Coupons </h4>
						</div>
						<div className="col-md-12">
							{this.state.coupons.length > 0 ? <div className="" style={{backgroundColor:'#fff'}}>{getcoupons}</div> : ''}
						</div>
					</div>
				</section> : ''}
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4" >Select Quantity</h4>
						</div>
						<div className="col-md-12" style={{backgroundColor:'#fff!important'}}>
								<div className="qty_section" style={{position:'relative',textAlign:'center'}}>
									<button className="minus_btn" onClick={()=>{this.decrementMinQty()}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/minus_orange.png'} alt=" " /></button>
									<span className="min_qty_btn"><input type="text" placeholder={this.state.min_allowed_qty1} value={this.state.min_allowed_qty} ref="input_minqty" onChange={this.updateMinQty} /></span>
									<button className="plus_btn" onClick={()=>{this.incrementMinQty()}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/plus.png'} alt=" " /></button>
									<button className="equal_btn"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/equalto.png'} alt="" /> </button>
									<span className="seed_qty_value"><span className="qty_mainvalue">{this.state.millions}</span><br/><span className="qty_unitname">Millions</span></span>
									<i className="millions_img"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/box_seed_quantity.png'} alt="" width="80px"/></i>
									{this.state.err_qty_status_1 ? <p className="err_seedlimit">{this.state.err_qty_msg}</p> : '' }
								{/*	{this.state.min_allowed_qty_status ? <p className="err_seedlimit">* Maximum Quantity is {this.state.available_qty}</p> : ''}*/}
								</div>
						</div>
					</div>
				</section>
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4">Select PL Size & Salinity</h4>
						</div>
						<div className="col-md-12" style={{backgroundColor:'#fff',paddingTop:'10px',paddingBottom:'15px',overflow:'hidden'}}>
							<div className="col-md-6 col-sm-6 col-xs-6" style={{padding:'0px'}}>
								<select value={this.state.plsize} onChange={()=>{this.plsizeChange()}} className="form-control select_plsize" ref="select_plsize" >
									<option key="0" value="0" selected={parseInt(this.state.cart_pl_size,10)===0 ? 'selected' : ''}>PL Size</option>
									{plsizes}
								</select>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-6" style={{paddingRight:'0px'}}>
								<select value={this.state.salinity} onChange={()=>{this.salinityChange()}} ref="select_salinity" className="form-control select_salinity">
									<option key="0" value="0" selected>Salinity</option>
									{salinities}
								</select>
							</div>
						</div>
					</div>
				</section>
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4" >Select Date</h4>
						</div>
					</div>
					<div className="mob_select_date" style={{position:'relative'}}>
						<img src={'https://aquadeals.in/admin/assets/mob-assets/back_orange.png'} alt="" className="left_arrow_date" />
						<Swiper {...params} key={seeddates.length}>
							{seeddates}
						</Swiper>
						<img src="https://aquadeals.in/admin/assets/mob-assets/forward_orange.png" alt="" className="right_arrow_date" />
							{this.state.err_date_status ? <p className="err_dateselect">{this.state.err_date}</p> : ''}
					</div>
						{/*<div className="date_arrows">
							<img src="https://aquadeals.in/admin/assets/mob-assets/back_orange.png" style={{position: 'absolute',left: '0px'}} />
							<img src="https://aquadeals.in/admin/assets/mob-assets/forward_orange.png" style={{position: 'absolute',right: '0px'}} />
						</div> */}
				</section>
				{this.state.free_shipment ==='1' ?
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4">Free Shipment</h4>
						</div>
					</div>
						<div className="row mob_pinblk">
							{this.state.free_shipment ==='1' ?
							<div className="col-md-12 col-sm-12 col-xs-12">
								<div className="mob_pin_inputblk">
									<input type="text" placeholder="Pincode" value={this.state.user_zipcode==='0' ? '' : this.state.user_zipcode} maxLength={6} ref="pincode" onChange={()=>{this.pincodeChange()}} />
									<a className="mob_pin_btn" onClick={()=>{this.checkPincode()}}>Check</a>
								</div>
								{this.state.err_pincode ? <p className="err_pincode">{this.state.err_pincode_msg}</p> : ''}
								<h5><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/shipping_van.png'} alt=""/></i><span>{this.state.free_ship_msg}</span></h5>
							</div>
						:
						 ''}
						</div>
				</section> : ''}
				{/* <h4 style={{fontSize:'13px',color:'#666',padding:'5px 0px 5px 14px'}}>Payment &amp; Delivery</h4>
				<section className="container-fluid">
					<div className="row key_featurs">
						<div className="col-md-12">
							{/* {shipment} */}
							{/* <h5><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/typicalshipping.png'} alt=" " /></i>Typically ships in 4-5 days</h5>
							{credit}
							<h5><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/onlinepay.png'} alt=" " /></i>Online Payment Available</h5>
						</div>
					</div>
				</section>
				*/}
				
				
				{this.state.deal_options.length > 0 || this.state.hatchary_details.caa === "Yes" ? <div className="block_header"><h4 className="mob_seed_h4">Key Features</h4></div> : ''}
				{this.state.deal_options && this.state.hatchary_details.caa === "Yes" ? 
					<div className="row key_featurs">
						<div className="col-md-12 col-sm-12 col-xs-12">
							<div className="col-md-6 col-xs-6 col-sm-6">
								 {this.state.hatchary_details.caa === "Yes" ? <h5><span>CAA Approved</span> </h5> : ''}
							</div>
							<div className="col-md-6 col-xs-6 col-sm-6" style={{padding:'0px'}} >
								{this.state.hatchary_details.caa ==="Yes" ? <h5 className="caa_approved">Yes, Vallid till {this.state.hatchary_details.caa_date}</h5> : ''}
							</div>
						</div>
					</div> : ''}
				{this.state.deal_options.length > 0 ?	<section className="container-fluid">
					<div className="row key_featurs">
						<div className="col-md-6 col-xs-6 col-sm-6">
							 {this.state.hatchary_details.caa === "Yes" ? <h5><span>CAA Approved</span> </h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.hatchary_details.caa ==="Yes" ? <h5>Yes, Vallid till {this.state.hatchary_details.caa_date}</h5> : ''}
						</div>
						<div className="clr"></div>
						{/* brod_name */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.brod_name !=="0" ? <h5><span>Brood Stock Source</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.brod_name !=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.brod_name}</span></h5> : ''}
						</div>
						<div className="clr"></div>
						{/* nauplii */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.nauplii!=="0" ? <h5><span>Nauplii</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.nauplii!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.nauplii}</span></h5> : ''}
						</div>
						<div className="clr"></div>
						{/* Feed */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.feed_sub!=="0" ? <h5><span>Feed</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.feed_sub!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.feed_sub}</span></h5> : ''}
						</div>
						<div className="clr"></div>
						{/* cultrDays_days */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.cultrDays_days!=="0" ? <h5><span>Cultured Days</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.cultrDays_days!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.cultrDays_days}</span></h5> : ''}
						</div>
						<div className="clr"></div>
						{/* pkg_size */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.pkg_size!=="0" ? <h5><span>Minimum Packing Size</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.pkg_size!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.pkg_size}</span></h5> : ''}
						</div>
					    {/* daign_name */}
					    <div className="clr"></div>
					    <div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.daign_name!=="0" ? <h5><span>Diagnosis</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.daign_name!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.daign_name}</span></h5> : ''}
						</div>
						{/* pcr_tests */}
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.pcr_tests!=="0" ? <h5><span>PCR Tests</span></h5> : ''}
						</div>
						<div className="col-md-6 col-xs-6 col-sm-6">
							{this.state.deal_options.pcr_tests!=="0" ? <h5 className="mob_feature_desc"><span>{this.state.deal_options.pcr_tests}</span></h5> : ''}
						</div>
					</div>
				</section> : ''}
				<section className="container-fluid">
					<div className="row">
						<div className="block_header">
							<h4 className="mob_seed_h4">More about the Seller</h4>
						</div>
					</div>
					<div className="row key_featurs">
						<div className="col-md-12">
							<div className="row">
								<div className="col-md-10 col-xs-10 col-sm-10">
									{this.state.hatchary_details.org_name ? <h5><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/home.png'} alt="aqua" /></i>{this.state.hatchary_details.org_name}</h5> : ''}
									{this.state.hatchary_details.coast ? <h5><i style={{marginTop:'1px'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/hat_loc.png'} alt="aqua" /></i>{this.state.hatchary_details.coast}</h5> : ''}  
								</div>
								<div className="col-md-2 col-xs-2 col-sm-2">
									{this.state.rate >= 1 ? <div className="seler_rating">{this.state.rate}</div> : ''}
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<section className="botm_btns container-fluid">
					<ul>	
						<li className="col-md-6 col-xs-6 col-sm-6 mob_req_btn" onClick={()=>{this.checkBestPrice()}}><Link title=""><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/get_best_price.png'} alt=" " /></i>GET BEST PRICE</Link> </li>
						{/*<li className="col-md-6 col-xs-6 col-sm-6" style={{cursor:'pointer'}}><Link onClick={()=>{this.setState({ reqbestPrice: true,})}} title=""><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/get_best_price.png'} alt=" " /></i>GET BEST PRICE</Link> </li>*/}
						<li className="col-md-6 col-xs-6 col-sm-6 mob_addto_cart_btn" onClick={()=>{this.placeOrderModal()}}><Link>{this.state.addtocart_msg}</Link></li>
					</ul>	
					<Modal className="showModal" show={this.state.showModal} onHide={this.close} >
						<Modal.Header closeButton>
		            		<Modal.Title style={{fontSize: '16px',color:'#333'}}>AquaDeals</Modal.Title>
		          		</Modal.Header>
		          		<Modal.Body>
		          			<h4 style={{fontSize:'14px', color:'#666'}}>You need to install Android mobile app to prebook seed.</h4>
		          		</Modal.Body>
		          		<Modal.Footer className="modal_footer">
		       				<Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.close}>Close</Button>
		       				<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
		          		</Modal.Footer>
					</Modal>	
				</section>
			</div>  :  
			<div>{this.state.data_status ? <NotFound /> : <div className="mob_loading">
				<img src={'https://aquadeals.in/admin/assets/images/web_imgs/mob_loading.gif'} alt="Loading" role="presentation" /></div> } </div>}
				{/* <Modal className="m_pro_full_dtls_modal"  show={this.state.reqbestPrice} onHide={this.close}  >
						<Modal.Header closeButton>
				    		<Modal.Title style={{fontSize: 16+'px',color:'#333'}}>AquaDeals</Modal.Title>
				  		</Modal.Header>
				  		<Modal.Body>
				  			<h4 style={{fontSize:'14px', color:'#666'}}>You need to install Android mobile app to get best price.</h4>
				  		</Modal.Body>
				  		<Modal.Footer className="modal_footer">
				  				<Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.close}>Close</Button>
				  				<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
				  		</Modal.Footer>
				</Modal> */}
				<Modal className="m_pro_full_dtls_modal"  show={this.state.clearcart_status} onHide={this.close}  >
					<Modal.Header closeButton>
			    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>Alert</Modal.Title>
			  		</Modal.Header>
			  		<Modal.Body>
			  			<h4 style={{fontSize:'14px', color:'#333'}}>You can't have multiple seller items in the cart. Empty existing cart & add this item {this.state.sp_name}?</h4>
			  		</Modal.Body>
			  		<Modal.Footer className="modal_footer">
			  			<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>NO</Button>
			  			<a><Button style={{background:'none',border:'none',color: '#ff742a'}} onClick={()=>{this.removeCartItems()}}>YES</Button></a>
			  		</Modal.Footer>
				</Modal>
				<Modal className="m_pro_full_dtls_modal"  show={this.state.product_existed} onHide={this.close}  >
					<Modal.Header closeButton>
			    		<Modal.Title style={{fontSize: '16px',color:'#333'}}>AquaDeals</Modal.Title>
			  		</Modal.Header>
			  		<Modal.Body>
			  			<h4 style={{fontSize:'14px', color:'#666'}}>Product already added to the cart</h4>
			  		</Modal.Body>
			  		<Modal.Footer className="modal_footer">
			  			<Button style={{background: 'none',border:'none',color:'#ff742a'}} onClick={this.close}>Close</Button>
			  		</Modal.Footer>
				</Modal>
				<Modal className="mob_reqbestprice"  show={this.state.reqbestPrice} onHide={this.close}  >
				<Modal.Body>
					<h4 className="req_title">REQUEST FOR BEST PRICE</h4>
					<p className="req_desc">For bulk order requirements please fill up the form we will get back with in 48hrs time.</p>
		  			<form className="req_best_price_form" onSubmit={this.reqBestPriceSubmit} >
		  				<input type="text" maxLength={10} id="req_quantity" ref="req_quantity" value={this.state.req_quantity} onChange={this.req_quantityChange} placeholder="Enter Quantity" />
		  				<span className="req_err" id="req_quantity_err"></span>
		  				{/*<Geosuggest fixtures={fixtures} placeholder="Select Address" onSuggestSelect={this.onSuggestSelect} ignoreTab={true} /> */}
		  				<input type="text" ref="req_state" id="req_state" value={this.state.req_state} onChange={this.req_stateChange} placeholder="Enter State" />
		  				<span className="req_err" id="req_state_err"></span>
		  				<input type="text" ref="req_city" id="req_city" value={this.state.req_city} onChange={this.req_cityChange} placeholder="Enter City / Town" />
		  				<span className="req_err" id="req_city_err"></span>
		  				<input type="text" ref="req_doorno" id="req_doorno" value={this.state.req_doorno} onChange={this.req_doornoChange} placeholder="Door No / Landmark" />
		  				<span className="req_err" id="req_doorno_err"></span>
		  				<input type="text" maxLength={6} ref="req_pincode" id="req_pincode" value={this.state.req_pincode} onChange={this.req_pincodeChange} placeholder="Pincode" />
		  				<span className="req_err" id="req_pincode_err"></span>
		  				<div className="req_footer">
		  					<a onClick={this.close}>CANCEL</a>
		  					<button type="submit">SEND</button>
		  				</div>
		  				{/*<input type="text" ref="quantity" placeholder="Enter Quantity" />
		  					<input type="text" ref="doorno" placeholder="Door no / Landmark" />
		  				 	<h5 onClick={this.editCityAddress} style={{fontSize:'12px'}}>{this.state.city && !this.state.editCityAddress_status ? this.state.city : <Geosuggest fixtures={fixtures} placeholder="Select Address" onSuggestSelect={this.onSuggestSelect} ignoreTab={true} onSelect={this.onSelect}/>}</h5>
		  				 	<Button style={{color:'#ff742a',border:'none'}} onClick={this.close}>Cancel</Button>
		  				 	<a onClick={()=>{this.handleFormSubmit()}}>SEND</a> */}
		  			</form>
		  		</Modal.Body>
		  	</Modal>
		  	<Modal className="mob_reqbestprice"  show={this.state.req_confirm_modal} onHide={this.close}  >
				<Modal.Body>
					{this.state.req_confirm_message}
					<a onClick={this.close} className="req_conf_ok_btn">OK</a>
		  		</Modal.Body>
		  	</Modal>
		</div>
  );
 }
}

export class ProductDetails extends Component {
	constructor(){
	 super();
	    this.state={
	      seedid: localStorage.getItem('seed_id'),
	    }
	    
	}
  	render(){
		var mydetails=this.props.data;
	return(
		<div>
			{mydetails.deals_data.oname ? <h4 style={{color:'#666',paddingTop:'5px',fontWeight:'bold'}}>{mydetails.deals_data.oname}</h4> : ''}
			{mydetails.deals_data.sname ? <h5>{mydetails.deals_data.sname}</h5> : ''}
			{/* {mydetails.deals_data.discount_price >0 ? <p><span className="offer_old">&#8377;{mydetails.deals_data.price}</span> <span className="offer_new">&#8377;{mydetails.deals_data.discount_price}</span></p> :  <p><span className="offer_new_single">&#8377;{mydetails.deals_data.price}</span></p> } */}
			{mydetails.deals_data.price ? <p style={{fontWeight:'bold'}}>MRP <span></span><span style={{color:'#333'}}>&#8377; </span><span style={{color:'#666'}}>{mydetails.deals_data.price}</span></p> : ''}
		</div>
	);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Seed/SeedDetails.js
 **/